import styled from 'styled-components';

import Page from 'components/layouts/page/Page';

export default function DischargeCalendarPage() {
  return (
    <Page>
      <Page.Header>
        <HeaderContent>
          <Page.Title>Discharge Calendar</Page.Title>
        </HeaderContent>
      </Page.Header>
      <Page.Content>
        <PlaceholderContent>
          <PlaceholderText>Discharge Calendar coming soon</PlaceholderText>
        </PlaceholderContent>
      </Page.Content>
    </Page>
  );
}

const HeaderContent = styled.div`
  padding: 24px;
`;

const PlaceholderContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

const PlaceholderText = styled.p`
  color: ${({ theme }) => theme.colors.black50};
  font-size: 16px;
`;
